export default {
    ACCEPT_AGREEMENT: 'ACCEPT_AGREEMENT',
    APPROVE_DISCOUNT: 'APPROVE_DISCOUNT',
    APPROVE_ITEM: 'APPROVE_ITEM',
    DELAY_PAYMENT: 'DELAY_PAYMENT',
    REVERT_PAYMENT: 'REVERT_PAYMENT',
    REJECT_AGREEMENT: 'REJECT_AGREEMENT',
    SUGGEST_DISCOUNT: 'SUGGEST_DISCOUNT',
};



// WEBPACK FOOTER //
// ./safeTrade/viewActions.js